import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useMain = () => {
  return useQuery({
    queryKey: ["mainState"],
    queryFn: async () =>
      callApi({
        path: "main",
        command: "main",
        data: "{data:0}",
      }),
  });
};
